export const checkIfStatusIsNewer = (newStatus?: string, oldStatus?: string) => {
    if (!newStatus || !oldStatus) {
        return false
    }

    return +newStatus.replace("-", ".") >= +oldStatus.replace("-", ".")
}
